export function newNoticeCategory(noticeCategory) {
  return {
    type: "NEW_NOTICE_CATEGORY",
    data: noticeCategory
  };
}

export function editNoticeCategory(noticeCategory) {
  return {
    type: "EDIT_NOTICE_CATEGORY",
    data: noticeCategory
  };
}



// WEBPACK FOOTER //
// ./src/actions/noticeCategories.js